module.exports = __webpack_public_path__ + "static/media/view leave.bd6d94e5.svg";